import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { RegulationsComponent } from "../pages/regulations/regulations.component";
import { AboutUsComponent } from "../pages/about-us/about-us.component";
import { PaymentsMethodsComponent } from "../pages/payments-methods/payments-methods.component";
import { HowBuyComponent } from "../pages/how-buy/how-buy.component";
import { ContactComponent } from "../pages/contact/contact.component";
import { LoginComponent } from "../pages/auth/login/login.component";
import { RegisterPageComponent } from "../pages/auth/register-page/register-page.component";
import { ForgotPasswordPageComponent } from "../pages/auth/forgot-password-page/forgot-password-page.component";
import { MainPageComponent } from "../pages/main-page/main-page.component";
import { SearchComponent } from "../pages/search/search.component";
import { UserAccountComponent } from "../pages/user-account/userAccount.component";
import { ChangeEmailComponent } from "../pages/user-account/change-email/changeEmail.component";
import { UserDetailsComponent } from "../pages/user-account/user-details/userDetails.component";
import { ChangePasswordComponent } from "../pages/user-account/change-password/changePassword.component";
import { MyOrdersComponent } from "../pages/user-account/my-orders/myOrders.component";
import { PrepaidComponent } from "../pages/prepaid/prepaid.component";
import { TransactionCompletedComponent } from "../pages/transaction-completed/transaction-completed.component";
import { AdminPanelComponent } from "../pages/admin-panel/admin-panel.component";
import { ArrangerDetailsComponent } from "../pages/user-account/arranger-details/arranger-details.component";
import { UserFullDetailsComponent } from "../pages/admin-panel/user-full-details/user-full-details.component";
import { UsersComponent } from "../pages/admin-panel/users/users.component";
import { AddNotesComponent } from "../shared/user/arranger/add-notes/add-notes.component";
import { NoteListComponent } from "../shared/user/arranger/note-list/note-list.component";
import { CategoryManagementComponent } from "../pages/admin/category-management/category-management.component";
import { DataExportComponent } from "../pages/admin-panel/data-export/data-export.component";
import { NotePageComponent } from "../pages/note-page/note-page.component";
import { InformationPageEditorComponent } from "../pages/admin-panel/information-pages/information-page-editor/information-page-editor.component";
import { CartPageComponent } from "../pages/cart-page/cart-page.component";
import { InformationPagesComponent } from "../pages/admin-panel/information-pages/information-pages.component";
import { AddPhotoComponent } from "../pages/user-account/add-photo/add-photo.component";
import { InvoiceDataComponent } from "../pages/admin-panel/invoice-data/invoice-data.component";
import { PrepaidsComponent } from "../pages/admin-panel/prepaids/prepaids.component";
import { ContractDataComponent } from "../pages/admin-panel/contract-data/contract-data.component";
import { OrderManagementComponent } from "../pages/admin-panel/order-management/order-management.component";
import { ContractsComponent } from "../shared/contracts/contracts.component";
import { ZaiksReportComponent } from "../pages/admin-panel/zaiks-report/zaiks-report.component";
import { DeleteAccountComponent } from "../pages/user-account/delete-account/delete-account.component";
import { AuthGuard } from "../guard/auth.guard";
import { InvoiceDetailsComponent } from "../pages/user-account/invoice-details/invoice-details.component";
import { ProfitComponent } from "../pages/arranger/profit/profit.component";
import { InvoiceManagementComponent } from "../pages/admin-panel/invoice-management/invoice-management.component";
import { SuccessComponent } from "../shared/user/arranger/add-notes/success/success.component";
import { NotesDownloadComponent } from "../pages/admin-panel/notes-download/notes-download.component";
import { InvoiceListComponent } from "../shared/invoice-list/invoice-list.component";
import { SongSuggestionPageComponent } from "../pages/song-suggestion-page/song-suggestion-page.component";
import { PrivacyComponent } from "../pages/privacy/privacy.component";
import { NewsletterUnsubscribePageComponent } from "../pages/newsletter/newsletter-unsubscribe-page/newsletter-unsubscribe-page.component";
import { NewsletterCreateComponent } from "../pages/admin-panel/newsletter-create/newsletter-create.component";
import { NewsletterComponent } from "../pages/admin-panel/newsletter/newsletter.component";
import { NewsletterSendListComponent } from "../pages/admin-panel/newsletter-send-list/newsletter-send-list.component";
import { NewsletterOptionsComponent } from "../shared/newsletter/newsletter-options/newsletter-options.component";
import { PrepaidInvoicesComponent } from "../pages/admin-panel/prepaid-invoices/prepaid-invoices.component";

const routes: Routes = [
  { path: "", component: MainPageComponent, pathMatch: "full" },
  {
    path: "koszyk",
    component: CartPageComponent,
  },
  {
    path: "regulamin",
    component: RegulationsComponent,
  },
  {
    path: "polityka-prywatnosci",
    component: PrivacyComponent,
  },
  {
    path: "onas",
    component: AboutUsComponent,
  },
  {
    path: "kontakt",
    component: ContactComponent,
  },
  {
    path: "sposobyplatnosci",
    component: PaymentsMethodsComponent,
  },
  {
    path: "jakkupowac",
    component: HowBuyComponent,
  },
  {
    path: "login",
    component: LoginComponent,
  },
  {
    path: "register",
    component: RegisterPageComponent,
  },
  {
    path: "forgotpassword",
    component: ForgotPasswordPageComponent,
  },
  {
    path: "szukaj",
    component: SearchComponent,
  },
  {
    path: "zasugeruj",
    component: SongSuggestionPageComponent,
  },
  {
    path: "transaction-completed",
    component: TransactionCompletedComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "newsletter-rezygnacja/:code",
    component: NewsletterUnsubscribePageComponent,
  },
  {
    path: "administrator-panel",
    component: AdminPanelComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      { path: "all-users", component: UsersComponent },
      { path: "invoices", component: InvoiceManagementComponent },
      {
        path: "user-full-details/:id/:role",
        component: UserFullDetailsComponent,
      },
      { path: "categories", component: CategoryManagementComponent },
      { path: "data-export", component: DataExportComponent },
      { path: "information-pages", component: InformationPagesComponent },
      {
        path: "information-page-editor/:id/:lang/:desc",
        component: InformationPageEditorComponent,
      },
      { path: "invoice-data", component: InvoiceDataComponent },
      { path: "prepaids", component: PrepaidsComponent },
      { path: "prepaid-invoices", component: PrepaidInvoicesComponent },
      { path: "contract-data", component: ContractDataComponent },
      { path: "orders-management", component: OrderManagementComponent },
      { path: "zaiks-report", component: ZaiksReportComponent },
      { path: "contracts", component: ContractsComponent },
      { path: "notes-download", component: NotesDownloadComponent },
      { path: "newsletter", component: NewsletterComponent },
      { path: "newsletter-create", component: NewsletterCreateComponent },
      { path: "newsletter-create/:id", component: NewsletterCreateComponent },
      { path: "newsletter-send-list", component: NewsletterSendListComponent },
    ],
  },
  {
    path: "my-account",
    component: UserAccountComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      { path: "my-details", component: UserDetailsComponent },
      { path: "invoices", component: InvoiceListComponent },
      { path: "change-email-address", component: ChangeEmailComponent },
      { path: "change-password", component: ChangePasswordComponent },
      { path: "newsletter-rezygnacja", component: NewsletterOptionsComponent },
      { path: "my-orders/:slug/:id", component: MyOrdersComponent },
      { path: "my-orders/:id", component: MyOrdersComponent },
      { path: "my-orders", component: MyOrdersComponent },
      { path: "invoice-details", component: InvoiceDetailsComponent },
      { path: "arranger-details", component: ArrangerDetailsComponent },
      { path: "add-note", component: AddNotesComponent },
      { path: "success", component: SuccessComponent },
      { path: "note-list", component: NoteListComponent },
      { path: "note-edit/:id", component: AddNotesComponent },
      { path: "add-photo", component: AddPhotoComponent },
      { path: "delete-account", component: DeleteAccountComponent },
      { path: "contracts", component: ContractsComponent },
      { path: "profit", component: ProfitComponent },
      {
        path: "prepaid-account",
        component: PrepaidComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "prepaid-account/:slug",
        component: PrepaidComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: "forgotpassword",
    component: ForgotPasswordPageComponent,
  },
  { path: "note/:id", component: NotePageComponent },
  { path: "note/:id/:title", component: NotePageComponent },
  { path: "**", redirectTo: "/" },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: "enabled",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
